<svelte:options customElement={{
  tag: 'checkbox-field',
  shadow: 'none',
  props: {
    name: { reflect: true, type: 'String' },
    options: { reflect: true, type: 'String' },
    legend: { reflect: true, type: 'String' },
    error: { reflect: true, type: 'String' }
  }
}} />

<script>
  /**
   * checkbox：チェックボックス
   * パーツライブラリ準拠の mod-fieldset / mod-checkbox 構造
   */
  export let name = 'check';
  export let options = '[]';
  export let legend = 'チェックボックス選択の説明テキスト';
  export let error = '';

  let parsedOptions = [];
  let selected = [];

  $: {
    try {
      parsedOptions = typeof options === 'string' ? JSON.parse(options) : (Array.isArray(options) ? options : []);
    } catch (e) {
      parsedOptions = [];
    }
  }
</script>

<div class:__error={!!error}>
  <fieldset class="mod-fieldset">
    <legend class="mod-fieldset-legend">{legend}</legend>
    {#each parsedOptions as option, i}
      <label class="mod-checkbox" for="{name}_{i}">
        <input
          type="checkbox"
          {name}
          id="{name}_{i}"
          value={option.value || option}
          bind:group={selected}
          on:change
        />
        <span class="mod-checkbox-text">{option.label || option}</span>
      </label>
    {/each}
  </fieldset>
  {#if error}
    <p class="color_red mt10">{error}</p>
  {/if}
</div>
